export default "https://ssr-releases-cdn.paperlesspost.com/_next/static/video/UYOMobileVideo-8f6dfcb79a088dd1fb5a9949ae546716.mp4";